var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"title":"查看奖品","size":600,"visible":_vm.drawerVisible},on:{"update:visible":function($event){_vm.drawerVisible=$event}}},[_c('SpFinder',{ref:"finder",attrs:{"row-key":"id","url":"/lottery/gift/extend/list","setting":_vm.setting,"no-selection":"","fixed-row-action":"","hooks":{ beforeSearch: _vm.beforeSearch }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }